import { TradeTalkStatus } from '@monorepo/types';
import { CreateTradeTalkDto } from './forms';

export type CommonResponse = {
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type TradeTalkBaseResponse<T> = {
  data: T;
  total: number;
};

export enum TradeTalkLabels {
  AllTalks = 'All Talks',
  Picks = 'Our Picks',
  MyTradeTalk = 'My Talks',
}

export const TradeTalkLabelsKeys = {
  [TradeTalkLabels.AllTalks]: 'tradeTalk:all_talks',
  [TradeTalkLabels.Picks]: 'tradeTalk:our_picks',
  [TradeTalkLabels.MyTradeTalk]: 'tradeTalk:my_talks',
} as const satisfies Record<TradeTalkLabels, string>;

export enum TradeTalkPrivacy {
  Public = 'public',
  Private = 'private',
}

export enum TradeTalkType {
  Analysis = 'analysis',
  Tutorial = 'tutorial',
}

export enum TradeTalkStrategy {
  Long = 'long',
  Neutral = 'neutral',
  Short = 'short',
}

export type TradeTalkCategory = CommonResponse & {
  name: string;
  parent?: string;
};

export type TradeTalkTag = CommonResponse & {
  name: string;
  userId: string;
};

export type TradeTalkLikes = {
  [userId: string]: TradeTalkUser & Omit<CommonResponse, 'id' | 'userId'>;
};

export type TradeTalkUser = {
  author: string;
  userImg: string;
  email: string;
};

export type TradeTalkResponse = CommonResponse &
  Omit<CreateTradeTalkDto, 'categories' | 'tags'> & {
    tags: TradeTalkTag[];
    categories: TradeTalkCategory[];
    status: TradeTalkStatus;
    isPick: boolean;
    nextPublishedAt: string;
    isReportedByCurrentUser?: boolean;
    sequence: number;
    user?: TradeTalkUser;
    descriptionText: string;
    userId: string;
    userPublicId: string;
    highlights?: SearchHighlight[];
    likes: TradeTalkLikes;
    commentsCount: number;
    symbol?: string;
  };

export type HighlightText = {
  type: 'text' | 'hit';
  value: string;
};

export type SearchHighlight = {
  path: 'descriptionText' | 'title';
  score?: number;
  texts: HighlightText[];
};

export type TradeTalkAdminResponse = TradeTalkResponse & {
  reportsCount: number;
  commentsReportsSum: number;
};

export type ArticleAdminResponse = Omit<
  TradeTalkAdminResponse,
  'commentsReportsSum'
> & {
  reportedCommentsCount: number;
};

export type TradeTalkAlertDto = Pick<TradeTalkResponse, 'userId' | 'title'> & {
  author: string;
};

export type TradeTalkCommentResponse = CommonResponse & {
  userPublicId: string;
  ideaId: string;
  parentId: string;
  content: string;
  likes: TradeTalkLikes;
  dislikes?: TradeTalkLikes;
  user: TradeTalkUser;
  isReportedByCurrentUser?: boolean;
  repliesCount?: number;
};

export type TradeTalkReportedCommentResponse = Omit<
  TradeTalkCommentResponse,
  'isReportedByCurrentUser'
> & {
  reportsCount: number;
};
